import { ReviewYourClaimForm } from "./Form";
import useReviewYourClaim from "./hooks/useReviewYourClaim";

export const ReviewYourClaim = () => {
  const props = useReviewYourClaim();
  return <ReviewYourClaimForm {...props} />;
};

export default ReviewYourClaim;
